// @flow
import * as React from 'react';

export const Sky = (props: { colorIndex: number }) => {
  return <div className={`background-sky background-sky-color-${props.colorIndex}`} />;
};
